import SkillCountComponent from './skillCount.component';

let SkillCountModule = angular.module('skillCount', [
])
.directive('skillCount', SkillCountComponent);

export default SkillCountModule;



// WEBPACK FOOTER //
// ./src/components/skillCount/skillCount.js